import { lazy, useContext } from "react";

const NotificationsList = lazy(() => import("./NotificationsList"));
const NotificationDetail = lazy(() => import("./NotificationDetail"));
const LicenceNotificationDetail = lazy(() => import("./LicenceNotificationDetail"));

const notificationsRoutes = [
    {
      path: "/notifications/list",
      component: NotificationsList
    },
    {
      path: "/notifications/detail/:id",
      component: NotificationDetail
    },
    {
      path: "/notifications/licence-notification/:licenceNotificationId",
      component: LicenceNotificationDetail
    },
  ];
  
  export default notificationsRoutes;